import {  GetPremiumResponse, SetPremiumRequest } from "Application/models";
import { APICallInstance } from "./APICallInstance";
import { AxiosResponse } from "axios";


export const fetchPremium = async (planId:any) => {
    const url = `api/v1/plan/${planId}/premiums`;

    try {
        const response: AxiosResponse<GetPremiumResponse> = await APICallInstance.get(url);
        console.log(response)
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const setPricingOnPlan = async (setBenefitsData: SetPremiumRequest, planId:any) => {
    const url = `api/v1/plan/${planId}/add/premium`;

    try {
        const response: AxiosResponse<GetPremiumResponse> = await APICallInstance.put(url, setBenefitsData);
        console.log(response)
        return response.data;
    } catch (error) {
        throw error;
    }
}